export const app_exists_not_exists_tr = {
  true: 'Var',
  false: 'Yok',
};
